"use strict";

var _require = require("../dist/converter"),
    convertToCustomFormat = _require.convertToCustomFormat,
    convertFromCustomFormat = _require.convertFromCustomFormat;

var _require2 = require("../dist/web-method-protocol"),
    resultToWebMethodPayload = _require2.resultToWebMethodPayload,
    exceptionToWebMethodPayload = _require2.exceptionToWebMethodPayload;

module.exports = {
  convertToCustomFormat: convertToCustomFormat,
  convertFromCustomFormat: convertFromCustomFormat,
  resultToWebMethodPayload: resultToWebMethodPayload,
  exceptionToWebMethodPayload: exceptionToWebMethodPayload
};